const config = {
  rootUrl: "https://oactp.dev-telematicsct.com",
  //rootUrl: "http://localhost:8080",
  apiKey: "rB67RCYtv3abKmz8JMuKL9E0gw3s3z4p5Rw4H0vW",
};
module.exports = config;